import { updateFilterWithProductStateExpression } from './update-filter-with-product-state-expression';
import { getSFCCReferralSourceCode } from '../../../sfcc/utilities/sfcc-referral-source-code-actions';
import { getSFCCRefererLink } from '../../../sfcc/utilities/sfcc-referer-link-actions';
/**
 * @internal
 */
export var getFetchSFCCSearchBody = function (searchParameters, includeType) {
    if (includeType === void 0) { includeType = "available" /* Available */; }
    var top = searchParameters.top, skip = searchParameters.skip, _a = searchParameters.search, search = _a === void 0 ? '' : _a, _b = searchParameters.filter, filter = _b === void 0 ? '' : _b, orderBy = searchParameters.orderBy, campaignId = searchParameters.campaignId;
    var filterWithProductState = updateFilterWithProductStateExpression(filter, includeType);
    var sourceCode = getSFCCReferralSourceCode();
    var referer = getSFCCRefererLink();
    return {
        search: search,
        filter: "(" + filterWithProductState + ")",
        campaignId: campaignId,
        top: top,
        skip: skip,
        orderBy: orderBy,
        sourceCode: sourceCode,
        referer: referer,
    };
};
